<template>
  <el-dialog
    class="theme-dialog dialog-body-0 seeting-fields-modal"
    title="设置样本显示内容"
    :visible.sync="visible"
    width="974"
    :destroy-on-close="true"
    top="50px"
    append-to-body
    :before-close="handleClose"
  >
    <div class="seeting-fields">
      <div class="left-seeting">
        <div class="checkbox-list">
          <el-checkbox-group  v-model="checkList" size="small">
            <el-checkbox :disabled="item.disabled" v-for="item in checkBoxData" :key="item.value"  :label="item.value">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="flex justify-between items-center footer-btns">
          <div>
            <el-checkbox v-model="isAllChecked" :indeterminate="isIndeterminate" @change="handleCheckAll">全选</el-checkbox>
          </div>
          <div>
            <el-button @click="handleClose" style="width:88px;border-color: #CCCCCC;color: rgba(0, 0, 0, 0.45);" >取消</el-button>
            <el-button @click="handleSubmit" style="width:88px" type="primary">确定</el-button>
          </div>
        </div>
      </div>
      <div class="right-adv">
        <p class="right-title"><i></i>设置样本显示内容</p>
        <div class="app-show-tips">
          设置样本显示内容，便于调查员执行任务时查看，示例如下
        </div>
        <img class="app-img" src="../../../../../assets/img/app.png" alt="app占位图" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import appImg from '@/assets/img/app.png'
export default {
  name:'InitSample',
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    checkBoxData:{
      type:Array,
      default:[]
    },
    checkedSeetingFields:{
      type:Array,
      default:[]
    }
  },
  watch:{
    visible(val){
      if(val && this.checkBoxData.length > 0){
        const copyCheckList = [];
        this.checkBoxData.forEach(item => {
          if(item.disabled){
            copyCheckList.push(item.value)
          }
        })
        // this.checkList = copyCheckList;
        this.checkList = [...new Set([ ...copyCheckList, ...this.checkedSeetingFields, ])] 
      }
    },
    checkedSeetingFields(val){
      if( val instanceof Array && val.length>0){
        this.checkList = val;
      }
    }
  },
  computed:{
    max(){
      return this.checkBoxData.filter(it=>it.disabled).length + 3
    },
    // 可选的选项（非disabled的）
    selectableItems(){
      return this.checkBoxData.filter(item => !item.disabled)
    },
    // 全选状态
    isAllChecked:{
      get(){
        return this.selectableItems.length > 0 && this.selectableItems.every(item => this.checkList.includes(item.value))
      },
      set(){}
    },
    // 半选状态
    isIndeterminate(){
      const checkedCount = this.selectableItems.filter(item => this.checkList.includes(item.value)).length
      return checkedCount > 0 && checkedCount < this.selectableItems.length
    }
  },
  data(){
    return {
      checkList: [],
    }
  },
  methods:{
    handleClose(){
      this.$emit('handleClose', false);
    },
    handleSubmit(){
      this.$emit('handleClose', false, this.checkList);
    },
    handleCheckAll(val){
      // 获取所有disabled项的值（必选项）
      const disabledValues = this.checkBoxData.filter(item => item.disabled).map(item => item.value)
      if(val){
        // 全选：disabled项 + 所有可选项
        const allValues = this.checkBoxData.map(item => item.value)
        this.checkList = allValues
      } else {
        // 取消全选：只保留disabled项
        this.checkList = disabledValues
      }
    }
  }
}
</script>
<style lang="scss">
  .seeting-fields-modal {
    .seeting-fields{
      width: 100%;
      height: 631px;
      background-color: #F5F5F5;
      display: flex;
      .left-seeting{
        flex: 1;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        .checkbox-list{
          flex: 1;
          padding: 16px;
          height: calc(100% - 65px);
          overflow: auto;
          .el-checkbox{
            width: 100%;
            padding: 5.5px 12px;
            border: 1px dashed #eee;
            margin-bottom: 12px;
            margin-right: 0;
            box-sizing: border-box;
            &.is-checked{
              background-color: rgba(39, 117, 232, 0.1);
              border-color: #2775E8;
            }
            &.is-disabled{
              background-color: rgba(0,0,0,0.08);
            }
            .el-checkbox__input.is-disabled+span.el-checkbox__label{
              color: rgba(0,0,0,0.45);
            }
          }
        }
        .footer-btns{
          box-sizing: border-box;
          padding: 16px;
          text-align: right;
          border-top: 1px solid rgba(0,0,0,0.1);
        }
      }
      .right-adv{
        width: 290px;
        background-color: #fff;
        margin-left: 15px;
        margin-bottom: 16px;
        margin-left: 16px;
        margin-right: 16px;
        padding: 16px;
        overflow: auto;
        .right-title{
          height: 22px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 16px;
          color: rgba(0,0,0,0.85);
          line-height: 22px;
          position: relative;
          i{
            position: absolute;
            left: -16px;
            top: 1px;
            display: block;
            width: 4px;
            height: 20px;
            background-color: #2775E8;
          }
        }
        .app-show-tips{
          margin-top: 8px;
          height: 48px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: rgba(0,0,0,0.65);
          line-height: 24px;
        }
        .app-img{
          margin-top: 8px;
          width: 100%;
          height: auto;
          display: block;
        }
      }
    }
  }

</style>